<template>
  <CModal
    :show.sync="visible"
    centered
    @hidden="onHidden"
  >
    <template #header>
      <div>
        <div class="d-flex align-items-center">
          <CIcon name="cipEmail" size="custom-size" width="36" height="36"
                 class="mr-3 icon-circle icon-circle--primary"/>
          <div>
            <h5 class="modal-title">
              <translate translate-context="collaborators.admin">Change account email</translate>
            </h5>
          </div>
        </div>
      </div>
      <CButtonClose @click="hide"/>
    </template>
    <div>
      <PAlert color="warning" class="mb-3">
        <div class="font-weight-medium mb-1"><translate translate-context="collaborators.admin">Warning:</translate></div>
        <p><translate translate-context="collaborators.admin">This operation will change the login email for this user across the entire system. The user will need to use the new email address to log in.</translate></p>
      </PAlert>

      <div class="form-group">
        <label class="font-weight-medium">
          <translate translate-context="collaborators.admin">Current Email</translate>
        </label>
        <CInput
          v-model="currentEmail"
          type="email"
          disabled
          readonly
          class="bg-light"
        />
      </div>

      <div class="form-group">
        <label for="new-account-email" class="font-weight-medium">
          <translate translate-context="collaborators.admin">New Email Address</translate>
        </label>
        <CInput
          id="new-account-email"
          v-model="form.email"
          type="email"
          required
          :placeholder="$pgettext('collaborators.admin', 'Enter new email address')"
          maxlength="254"
        />
        <div v-if="emailError" class="text-danger small mt-2">
          {{ emailError }}
        </div>
      </div>
    </div>

    <template #footer>
      <CButton color="secondary" @click="visible = false">
        <translate translate-context="collaborators.admin">Cancel</translate>
      </CButton>
      <CButton
        color="primary"
        @click="onSubmit"
        :disabled="!isFormValid || isSubmitting"
      >
        <span v-if="isSubmitting">
          <CSpinner size="sm" class="mr-1"/>
          <translate translate-context="collaborators.admin">Updating...</translate>
        </span>
        <span v-else>
          <translate translate-context="collaborators.admin">Change email</translate>
        </span>
      </CButton>
    </template>
  </CModal>
</template>

<script>
import { mapActions } from 'vuex'
import PAlert from "@/components/PAlert.vue";

export default {
  name: 'ChangeAccountEmailModal',
  components: {PAlert},

  data() {
    return {
      visible: false,
      collaborator: null,
      currentEmail: '',
      form: {
        email: ''
      },
      emailError: '',
      isSubmitting: false
    }
  },

  computed: {
    isFormValid() {
      return this.form.email &&
             this.form.email !== this.currentEmail &&
             this.validateEmail(this.form.email) &&
             !this.emailError
    }
  },

  methods: {
    ...mapActions('customerSuccess', [
      'changeAccountEmail'
    ]),

    show(collaborator) {
      this.collaborator = collaborator
      this.currentEmail = collaborator.email
      this.form.email = ''
      this.emailError = ''
      this.isSubmitting = false
      this.visible = true
    },

    hide() {
      this.visible = false
    },

    onHidden() {
      this.collaborator = null
      this.currentEmail = ''
      this.form.email = ''
      this.emailError = ''
      this.isSubmitting = false
    },

    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return re.test(email)
    },

    async onSubmit() {
      if (!this.isFormValid || this.isSubmitting) return

      this.isSubmitting = true
      this.emailError = ''

      try {
        await this.changeAccountEmail({
          userId: this.collaborator.user_id,
          email: this.form.email.toLowerCase()
        })

        await this.notifySuccess(this.$pgettext('collaborators.admin', 'Account email changed successfully'))
        this.$emit('updated')
        this.hide()
      } catch (error) {
        if (error.response?.data?.email) {
          this.emailError = error.response.data.email[0]
        } else if (error.response?.data?.detail) {
          this.emailError = error.response.data.detail
        } else {
          await this.notifyError(this.$pgettext('collaborators.admin', 'Failed to change account email'))
        }
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
</style>
